import type { ChangeEvent } from "react";
import { DateRangePicker, RadioGroup } from "@heroui/react";
import { I18nProvider } from "@react-aria/i18n";
import { useTranslation } from "react-i18next";
import CustomRadio from "../common/form/CustomRadio";
import type { DateRangeValue } from "./types";

interface OrdersDateFilterProps {
  value: DateRangeValue | null;
  onChange: (value: DateRangeValue | null) => void;
  onRadioChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export function OrdersDateFilter({ value, onChange, onRadioChange }: Readonly<OrdersDateFilterProps>) {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-xl flex flex-row gap-4">
      <I18nProvider locale="fr-FR">
        <DateRangePicker
          showMonthAndYearPickers
          granularity="day"
          variant="flat"
          value={value}
          onChange={onChange}
          selectorButtonPlacement="start"
          radius="full"
          size="sm"
          classNames={{
            base: "",
            inputWrapper: [
              "border-0",
              "bg-white",
              "h-9",
              "min-h-unit-9",
              "hover:bg-white",
              "group-data-[hover=true]:bg-white",
              "group-data-[focus=true]:bg-white",
            ],
            input: ["text-vistagrey", "normal-nums", "font-medium"],
          }}
          CalendarBottomContent={
            <RadioGroup
              aria-label="Date precision"
              classNames={{
                base: "w-full pb-2",
                wrapper:
                  "-my-2.5 py-2.5 px-1 gap-1 flex-nowrap max-w-[w-[calc(var(--visible-months)_*_var(--calendar-width))]] overflow-scroll",
              }}
              orientation="horizontal"
              onChange={onRadioChange}
            >
              <CustomRadio value="30">30 {t("day_plural")}</CustomRadio>
              <CustomRadio value="7">7 {t("day_plural")}</CustomRadio>
              <CustomRadio value="3">{t("reset")}</CustomRadio>
            </RadioGroup>
          }
        />
      </I18nProvider>
    </div>
  );
};

export default OrdersDateFilter;
